(ns motorsaif.web.admin-subs
  (:require
   [re-frame.core :as rf :refer [reg-sub]]))

(reg-sub :admin-overlay
  (fn [db _]
    (get-in db [:ui-state :admin-overlay])))

(reg-sub :admin-data
  (fn [db [_ table id]]
    (cond id
          (get-in db [:admin-data table id])
          table
          (vals (get-in db [:admin-data table]))
          :else
          (vals (:admin-data db)))))

(reg-sub :admin/request-data
  (fn [db [_ request-id]]
    (get-in db [:admin-request-data request-id])))
